import * as React from 'react';
import Svg, {
  G,
  Polygon,
  SvgProps,
  Text,
} from 'react-native-svg';
import { isWeb } from '../../config/designSystem/Layout';

export const RibbonPsychoCard = (props: SvgProps) => {
  const { color, title } = props;
  const textXCoordinates = isWeb? 57:100;
  const textYCoordinates = isWeb? -10:80;
  return (
    isWeb?<Svg height="90" width="90">

      <Polygon points="0 0, 0 10, 10 0" fill={color} strokeWidth="0" />
      <Polygon points="-80 -80, 550 550, 90 50, 40 0" fill={color} strokeWidth="0" />
      <Polygon points="60 30, 70 80, 80 80" fill={color} strokeWidth="0" />
      <G rotation="45" origin="130, -20">
        <Text x={textXCoordinates} y={textYCoordinates} stroke="white" fill="white" textAnchor="middle"
        >
          {title}
        </Text>
      </G>
    </Svg>:<Svg height="70" width="70">
      <Polygon points="0 0, 0 10, 10 0" fill={color} strokeWidth="0" />
      <Polygon points="-50 -50, 100 100, 70 40, 30 0" fill={color} strokeWidth="0" />
      <Polygon points="60 60, 60 70, 70 70" fill={color} strokeWidth="0" />
      <G rotation="45" origin="130, -20">
        <Text x={textXCoordinates} y={textYCoordinates} stroke="white" fill="white" textAnchor="middle"
        >
          {title}
        </Text>
      </G>
    </Svg>
  );
};

